import {Col, DatePicker, Typography} from 'antd';
import dayjs from 'dayjs';
import {useFormikContext} from 'formik';
import React from 'react';
import {useSelector} from 'react-redux';
import {DATE_TIME_LOCALE} from 'Utils/constants/DateFormat';
import {fieldColProps, labelStyle} from '../gridHelpers';

export default function CustomDateTimePicker(props) {
  const textField = props.field;
  const {setFieldValue, values} = useFormikContext<any>();
  const tenantConfig = useSelector((state: any) => state?.login?.tenantConfig);
  const inputDateFormat = DATE_TIME_LOCALE[tenantConfig.locale];
  const format = textField?.dateFormat || inputDateFormat;

  return (
    <Col {...fieldColProps(textField)}>
      <Typography.Text style={labelStyle}>{textField?.fieldLabel}</Typography.Text>
      <DatePicker
        showTime
        format={format}
        style={{width: '100%'}}
        disabled={textField?.isDisabled ?? false}
        disabledDate={
          textField?.disablePast
            ? (current) => current && current < dayjs().startOf('day')
            : undefined
        }
        value={values[textField?.name] ? dayjs(values[textField?.name]) : null}
        onChange={(value) => setFieldValue(textField.name, value ? value.toDate() : null)}
      />
    </Col>
  );
}
